import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_customer",
  ref: "addCompanySettingModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_customer_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Industrial sector must be active"
}, null, -1)
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["value"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = { class: "d-flex align-items-center mt-3" }
const _hoisted_43 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_44 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_45 = { class: "form-check form-check-inline form-check-solid" }
const _hoisted_46 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = { class: "d-flex align-items-center mt-3" }
const _hoisted_53 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_54 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_55 = { class: "form-check form-check-inline form-check-solid" }
const _hoisted_56 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "col-lg-8 fv-row" }
const _hoisted_62 = { class: "d-flex mt-3 flex-column" }
const _hoisted_63 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_64 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_65 = { class: "form-check form-check-inline form-check-solid mt-1" }
const _hoisted_66 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_67 = { class: "form-check form-check-inline form-check-solid mt-1" }
const _hoisted_68 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = {
  id: "container-buttons",
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_72 = { class: "indicator-label" }
const _hoisted_73 = { class: "indicator-progress" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_75 = { class: "indicator-label" }
const _hoisted_76 = { class: "indicator-progress" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _ctx.createCompanyProfile,
        "validation-schema": _ctx.profileDetailsValidator
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate("UPDATE_YEARLY_AZIENDA_SETTINGS_MAIN_HEADER")), 1)
            ]),
            (
              _ctx.selectLists && _ctx.companyProfile &&
              ((_ctx.isAdmin && _ctx.company_per_year_parameters) || (!_ctx.isAdmin && _ctx.company_per_year_parameters && _ctx.azienda_yearly_parameters))
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate("AZIENDA_DENOM_STRING")), 1),
                    _createElementVNode("div", _hoisted_9, [
                      (!_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_Field, {
                            key: 0,
                            type: "text",
                            name: "denom",
                            class: "form-control form-control-lg",
                            placeholder: "Company name",
                            modelValue: _ctx.companyProfile.denom,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyProfile.denom) = $event)),
                            "aria-label": _ctx.translate('AZIENDA_DENOM_STRING')
                          }, null, 8, ["modelValue", "aria-label"]))
                        : (_openBlock(), _createBlock(_component_Field, {
                            key: 1,
                            type: "text",
                            name: "denom",
                            class: "form-control form-control-lg",
                            placeholder: "Company name",
                            modelValue: JSON.parse(_ctx.localStorage.getItem('simulate_user') as string)['denom'],
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((JSON.parse(_ctx.localStorage.getItem('simulate_user') as string)['denom']) = $event)),
                            "aria-label": _ctx.translate('AZIENDA_DENOM_STRING')
                          }, null, 8, ["modelValue", "aria-label"])),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "denom"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate("AZIENDA_SECTOR_STRING")), 1),
                      _hoisted_15
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                        ? (_openBlock(), _createBlock(_component_Field, {
                            key: 0,
                            as: "select",
                            name: "settore",
                            class: "form-select form-select-solid form-select-lg",
                            modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].settore,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].settore) = $event)),
                            "aria-label": _ctx.translate('AZIENDA_SECTOR_STRING')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.settori, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: index
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(item[_ctx.translateKey("descrizione")]), 1)
                                ], 8, _hoisted_17))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "aria-label"]))
                        : (_openBlock(), _createBlock(_component_Field, {
                            key: 1,
                            as: "select",
                            name: "settore",
                            class: "form-select form-select-solid form-select-lg",
                            "aria-label": _ctx.translate('AZIENDA_SECTOR_STRING')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.settori, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: index
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(item[_ctx.translateKey("descrizione")]), 1)
                                ], 8, _hoisted_18))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["aria-label"])),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "settore"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate("AZIENDA_REVENUE_STRING")), 1),
                    _createElementVNode("div", _hoisted_23, [
                      (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                        ? (_openBlock(), _createBlock(_component_Field, {
                            key: 0,
                            as: "select",
                            name: "fatturato",
                            class: "form-select form-select-solid form-select-lg",
                            modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].fatturato,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].fatturato) = $event)),
                            "aria-label": _ctx.translate('AZIENDA_REVENUE_STRING')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.fatturati, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: index
                                }, [
                                  (_ctx.locale === 'it')
                                    ? (_openBlock(), _createElementBlock("b", _hoisted_25, _toDisplayString(item.descrizione), 1))
                                    : (_openBlock(), _createElementBlock("b", _hoisted_26, _toDisplayString(item.descrizione_en), 1))
                                ], 8, _hoisted_24))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "aria-label"]))
                        : (_openBlock(), _createBlock(_component_Field, {
                            key: 1,
                            as: "select",
                            name: "fatturato",
                            class: "form-select form-select-solid form-select-lg",
                            "aria-label": _ctx.translate('AZIENDA_REVENUE_STRING')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.fatturati, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  key: index
                                }, [
                                  (_ctx.locale === 'it')
                                    ? (_openBlock(), _createElementBlock("b", _hoisted_28, _toDisplayString(item.descrizione), 1))
                                    : (_openBlock(), _createElementBlock("b", _hoisted_29, _toDisplayString(item.descrizione_en), 1))
                                ], 8, _hoisted_27))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["aria-label"])),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "fatturato"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.translate("AZIENDA_EMPLOYEES_RANGE_STRING")), 1),
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                        ? (_openBlock(), _createBlock(_component_Field, {
                            key: 0,
                            as: "select",
                            name: "employees_range",
                            class: "form-select form-select-solid form-select-lg",
                            modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].employees_range,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].employees_range) = $event)),
                            "aria-label": _ctx.translate('AZIENDA_EMPLOYEES_RANGE_STRING')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.employee_range, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.range_id,
                                  key: index
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(item.description), 1)
                                ], 8, _hoisted_35))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "aria-label"]))
                        : (_openBlock(), _createBlock(_component_Field, {
                            key: 1,
                            as: "select",
                            name: "employees_range",
                            class: "form-select form-select-solid form-select-lg",
                            "aria-label": _ctx.translate('AZIENDA_EMPLOYEES_RANGE_STRING')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.employee_range, (item, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.range_id,
                                  key: index
                                }, [
                                  _createElementVNode("b", null, _toDisplayString(item.description), 1)
                                ], 8, _hoisted_36))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["aria-label"])),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "employees_range"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate("AZIENDA_IS_ASSOCIATED_STRING")), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("label", _hoisted_43, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_associated",
                                value: 1,
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_associated,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_associated) = $event)),
                                "aria-label": _ctx.translate('CHANGE_ASSOCIATED_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_associated",
                                value: 1,
                                "aria-label": _ctx.translate('CHANGE_ASSOCIATED_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate("CHANGE_ASSOCIATED_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_45, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_associated",
                                value: 0,
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_associated,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_associated) = $event)),
                                "aria-label": _ctx.translate('CHANGE_NOT_ASSOCIATED_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_associated",
                                value: 0,
                                "aria-label": _ctx.translate('CHANGE_NOT_ASSOCIATED_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.translate("CHANGE_NOT_ASSOCIATED_OPTION")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "is_associated"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.translate("AZIENDA_IS_QUOTED_STRING")), 1),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_quoted",
                                value: 1,
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_quoted,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_quoted) = $event)),
                                "aria-label": _ctx.translate('CHANGE_QUOTED_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_quoted",
                                value: 1,
                                "aria-label": _ctx.translate('CHANGE_QUOTED_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.translate("CHANGE_QUOTED_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_55, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_quoted",
                                value: 0,
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_quoted,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].is_quoted) = $event)),
                                "aria-label": _ctx.translate('CHANGE_NOT_QUOTED_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "is_quoted",
                                value: 0,
                                "aria-label": _ctx.translate('CHANGE_NOT_QUOTED_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.translate("CHANGE_NOT_QUOTED_OPTION")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "is_quoted"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.translate("AZIENDA_COMPANY_TYPE_STRING")), 1),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "company_type",
                                value: "D01",
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].company_type,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].company_type) = $event)),
                                "aria-label": _ctx.translate('CHANGE_PMI_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "company_type",
                                value: "D01",
                                "aria-label": _ctx.translate('CHANGE_PMI_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.translate("CHANGE_PMI_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_65, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "company_type",
                                value: "D02",
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].company_type,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].company_type) = $event)),
                                "aria-label": _ctx.translate('CHANGE_SMALL_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "company_type",
                                value: "D02",
                                "aria-label": _ctx.translate('CHANGE_SMALL_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.translate("CHANGE_SMALL_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_67, [
                          (_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')])
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                type: "radio",
                                class: "form-check-input",
                                name: "company_type",
                                value: "D03",
                                modelValue: _ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].company_type,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.company_per_year_parameters[_ctx.isAdmin ? _ctx.localStorage.getItem('to_year_admin') : _ctx.localStorage.getItem('to_year')].company_type) = $event)),
                                "aria-label": _ctx.translate('CHANGE_LARGE_OPTION')
                              }, null, 8, ["modelValue", "aria-label"]))
                            : (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                type: "radio",
                                class: "form-check-input",
                                name: "company_type",
                                value: "D03",
                                "aria-label": _ctx.translate('CHANGE_LARGE_OPTION')
                              }, null, 8, ["aria-label"])),
                          _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.translate("CHANGE_LARGE_OPTION")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          (_ctx.isFormSubmitted)
                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                key: 0,
                                name: "company_type"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("button", {
                type: "button",
                id: "kt_account_profile_details_close",
                ref: "closeButton",
                class: "btn btn-white",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, [
                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.translate("BUTTON_CLOSE")), 1),
                _createElementVNode("span", _hoisted_73, [
                  _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                  _hoisted_74
                ])
              ], 512),
              _createElementVNode("button", {
                type: "submit",
                ref: "submitButton",
                id: "kt_account_profile_details_submit",
                class: "btn btn-dark-blue",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.translate("BUTTON_SUBMIT")), 1),
                _createElementVNode("span", _hoisted_76, [
                  _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_WAIT")) + " ", 1),
                  _hoisted_77
                ])
              ], 512)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 512))
}